// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import './assets/element-variables.scss'
import echarts from 'echarts'
import './common/common.scss'
import axios from 'axios'
import * as api from './util/api'
import request from './util/request'
import Utils from './util/utils'
import moment from "moment";
import Vuex from 'vuex'
import store from './store'
// import './util/menu'
Vue.use(Vuex)
import { parseTime, resetForm, isHospital, selectDictLabel, selectDictLabels } from "@/util/common.js";
// axios.defaults.baseURL='http://47.104.247.5:4000/'
axios.defaults.withCredentials = true
Vue.prototype.axios = axios
Vue.prototype.api = api
Vue.prototype.Utils = Utils
Vue.prototype.parseTime = parseTime
Vue.prototype.resetForm = resetForm
Vue.prototype.isHospital = isHospital
Vue.prototype.selectDictLabel = selectDictLabel
Vue.prototype.selectDictLabels = selectDictLabels

Vue.prototype.request = request
Vue.prototype.$echarts = echarts
Vue.config.productionTip = false




ElementUI.Dialog.props.closeOnClickModal.default = false
Vue.use(ElementUI);

Vue.filter('convertTime',function(data,formatStr){
  return moment(data).format(formatStr)
})

const whiteList = ['login'] // 路由白名单
router.beforeEach(function(to, from, next) {
  // 1. 白名单路由直接放行（login）
  if (whiteList.includes(to.name)) {
    next()
    return
  }

  // 2. 获取本地存储的 token 和菜单权限
  const token = window.localStorage.getItem('token')
  const menusStr = window.localStorage.getItem('ayMenus')
  const menus = menusStr ? JSON.parse(menusStr) : []

  // 3. 未登录（无 token）：跳转到登录页
  if (!token) {
    next({ name: 'login' })
    return
  }

  // 4. 已登录：优先放行 home 路由（有 token 就有 home 权限）
  if (to.path === '/home' || to.name === 'home') {
    next()
    return
  }
  // 权限校验 - 支持递归检查子菜单 items
  const hasPermission = (() => {
    // 定义递归检查函数
    const checkMenuPermission = (menus, targetPath) => {
      // 遍历菜单数组
      for (const menu of menus) {
        // 1. 检查当前菜单的 url 是否匹配
        if (typeof menu.url === 'string' && targetPath.includes(menu.url)) {
          return true;
        }

        // 2. 如果有子菜单 items，递归检查子菜单
        if (Array.isArray(menu.items) && menu.items.length > 0) {
          const hasChildPermission = checkMenuPermission(menu.items, targetPath);
          if (hasChildPermission) {
            return true;
          }
        }
      }
      // 所有菜单都不匹配
      return false;
    };
    // 执行递归检查
    return checkMenuPermission(menus, to.path);
  })();

  if (hasPermission) {
    next() // 有权限，正常放行
  } else {
    // 无论 menus 是否为空，只要没匹配到就提示无权限
    Vue.prototype.$message.error(`无权限访问 ${to.path}！`)
    // 你可根据需求选择跳转目标：home 或 login
    next({ path: '/home' })
    // 如果仍需跳登录：next({ name: 'login' })
  }
})


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  store,
  components: {
    App
  },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js